export default {
  init() {

  },
  finalize() {
    if ($(window).width() < 991) {
      $('.rtable').addClass('rtable--flip');
    } else {
      $('.rtable').removeClass('rtable--flip');
    }

    $(window).on('resize', function(){
      var win = $(this); //this = window
      if (win.width() <= 991) {
        $('.rtable').addClass('rtable--flip');
      } else {
        $('.rtable').removeClass('rtable--flip');
      }

    });

    jQuery('tbody tr').on('mouseover', function() {
      let $replaceContainer = jQuery(this).parents('.row.mb-5.mt-10').find('.overlay img');
      if(jQuery(this).data('status') !== '') {
        $replaceContainer.attr('src', $(this).data('highlight'));
      }
    });

    jQuery('tbody tr').on('mouseleave', function() {
      let $replaceContainer = jQuery(this).parents('.row.mb-5.mt-10').find('.overlay img')
      $replaceContainer.attr('src', $replaceContainer.data('base'));
    });

    jQuery('tbody tr').on('click', function(){
      if(jQuery(this).data('download') !== '' && (jQuery(this).data('status') !== 'sold' || jQuery(this).data('status') !== 'reserved') ) {
        window.open(jQuery(this).data('download'), '_blank');
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/wohnungen.js